import React from 'react';
import ReactLoading from 'react-loading';


export default class Loading extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return(
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <ReactLoading type={'bubbles'} color={'#5cb500'} height={100} width={100} />
            </div>
        );
    }
}
 